// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fG","homeTitle_styleDefault":"c-a_fH","homeTitle_styleRed":"c-a_fJ"};